module.exports = __webpack_public_path__ + "static/img/ccb.c55b665.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partners/ccb.png
// module id = aI2z
// module chunks = 1 2